/**
 * The typography object exports default styles for the defined display types
 * in template literal format. These styles are meant to be standard across
 * all apps on the site and should not be modified.
 */
const Typography = {
  displayLarge: `
    font: 54px HelveticaNeueLTStd-Md-Normalized, Helvetica, Arial, sans-serif;
    letter-spacing: -1px;
    line-height: 48px;
  `,
  displayCaps: `
    font: 56px HelveticaNeueLTStd-Md-Normalized, Helvetica, Arial, sans-serif;
    text-transform: uppercase;
    line-height: 64px;
  `,
  display: `
    font: 48px HelveticaNeueLTStd-Md-Normalized, Helvetica, Arial, sans-serif;
    letter-spacing: -1px;
    line-height: 52px;
  `,
  headline: `
    font: 32px HelveticaNeueLTStd-Bd-Normalized, Helvetica, Arial, sans-serif;
    line-height: 40px;
  `,
  headlineCaps: `
    font: 24px HelveticaNeueLTStd-Bd-Normalized, Helvetica, Arial, sans-serif;
    line-height: 32px;
    text-transform: uppercase;
  `,
  headlineLegal: `
    font: 16px HelveticaNeueLTStd-Bd-Normalized, Helvetica, Arial, sans-serif;
    line-height: 20px;
  `,
  subHeader: `
    font: 20px HelveticaNeueLTStd-Bd-Normalized, Helvetica, Arial, sans-serif;
    line-height: 24px;
  `,
  subHeaderCaps: `
    font: 16px HelveticaNeueLTStd-Bd-Normalized, Helvetica, Arial, sans-serif;
    line-height: 20px;
    text-transform: uppercase;
  `,
  bodyLarge: `
    font: 24px HelveticaNeueLTStd-Roman-Normalized, Helvetica, Arial, sans-serif;
    line-height: 32px;
  `,
  bodyBold: `
    font: 16px HelveticaNeueLTStd-Bd-Normalized, Helvetica, Arial, sans-serif;
    letter-spacing: 0.5px;
    line-height: 24px;
  `,
  bodyThin: `
    font: 16px HelveticaNeueLTStd-Lt-Normalized, Helvetica, Arial, sans-serif;
    letter-spacing: 0.5px;
    line-height: 24px;
  `,
  body: `
    font: 16px HelveticaNeueLTStd-Roman-Normalized, Helvetica, Arial, sans-serif;
    line-height: 24px;
  `,
  bodySmall: `
    font: 14px HelveticaNeueLTStd-Roman-Normalized, Helvetica, Arial, sans-serif;
    line-height: 12px;
  `,
  bodyLegal: `
    font: 12px HelveticaNeueLTStd-Cn-Normalized, Helvetica, Arial, sans-serif;
    line-height: 16px;
  `,
  buttonHeavy: `
    font: 16px HelveticaNeueLTStd-Bd-Normalized, Helvetica, Arial, sans-serif;
    letter-spacing: 1.8px;
    text-transform: uppercase;
  `,
  buttonSocial: `
    font: 16px HelveticaNeueLTStd-Lt-Normalized, Helvetica, Arial, sans-serif;
  `,
  buttonSmall: `
    font: 14px HelveticaNeueLTStd-Bd-Normalized, Helvetica, Arial, sans-serif;
    letter-spacing: 0.5px;
    line-height: 16px;
  `,
  button: `
    font: 16px HelveticaNeueLTStd-Bd-Normalized, Helvetica, Arial, sans-serif;
    letter-spacing: 0.5px;
    line-height: 20px;
  `,
  outline: `
    font: 56px HelveticaNeueLTStd-BdOu-Normalized, Helvetica, Arial, sans-serif;
    line-height: 64px;
    text-transform: uppercase;
  `,
};

/* @component */
export default Typography;
